export const ANO_LETIVO_ATUAL = new Date().getFullYear();

export const BIMESTRE_LABELS: Record<number, string> = {
  1: '1º Bim',
  2: '2º Bim',
  3: '3º Bim',
  4: '4º Bim',
};

export function corFrequencia(pct: number) {
  if (pct >= 80) return '#059669';
  if (pct >= 60) return '#d97706';
  return '#dc2626';
}

export function labelStatusFrequencia(pct: number, emRisco: boolean) {
  if (emRisco || pct < 75) return 'Risco';
  if (pct >= 80) return 'Adequado';
  return 'Atencao';
}

export function iniciaisNome(nome: string) {
  return nome
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0])
    .join('')
    .toUpperCase();
}
